import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Wrapper } from './styles';
import { ResourceSectionProps } from './types';

export const ResourceSectionPlaceholder: FC<ResourceSectionProps> = ({
  config,
}) => {
  const {
    resourceTemplateSectionId,
    resourceTemplateSectionType,
    resourceTemplateSectionFilterType,
    resourceTemplateSectionFilterRangeStr,
  } = config;

  return (
    <Wrapper id={resourceTemplateSectionId}>
      <FormattedMessage
        id="templates.status_updates.placeholder_text"
        values={{
          subtype: (
            <FormattedMessage
              id={`tasks.${resourceTemplateSectionFilterType}`}
            />
          ),
          range: resourceTemplateSectionFilterRangeStr,
          strong: () => <strong>{`${resourceTemplateSectionType}s `}</strong>,
        }}
      />
    </Wrapper>
  );
};
